module.exports = __webpack_public_path__ + "img/0x1A0c0F40150177b36F852Bf3732e8Ae4D524b7dD.7dbe2d18.png";